import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { UserRole } from '../../types/user'; // استيراد UserRole enum

// 1. تحديث الواجهة لتقبل مصفوفة من الأدوار المسموح بها
interface ProtectedRouteProps {
  children: React.ReactElement;
  allowedRoles: UserRole[]; // الخاصية الجديدة
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  // 2. الحصول على معلومات المستخدم الكاملة، وليس فقط حالة المصادقة
  const { isAuthenticated, user, isLoading } = useAuth();
  const location = useLocation();

  // 3. عرض شاشة تحميل أثناء التحقق من المصادقة
  if (isLoading) {
    // يمكنك عرض شاشة تحميل هنا لمنع الوميض (flickering)
    return <div>Loading...</div>; // أو <LoadingSpinner />
  }

  // 4. التحقق من تسجيل الدخول أولاً
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 5. التحقق من الدور (الأهم)
  // نتأكد من وجود المستخدم وأن دوره مدرج في قائمة الأدوار المسموح بها
  if (user && allowedRoles.includes(user.role)) {
    // إذا كان الدور مسموحاً به، اعرض المكون الفرعي
    return children;
  } else {
    // إذا لم يكن الدور مسموحاً به، قم بإعادة توجيهه
    // يمكنك إنشاء صفحة "غير مصرح به" (Unauthorized) لعرضها هنا
    // أو إعادته إلى صفحة تسجيل الدخول أو لوحة التحكم الرئيسية
    console.warn(`Access denied for role: ${user?.role}. Allowed roles: ${allowedRoles.join(', ')}`);
    return <Navigate to="/unauthorized" replace />; // <-- مسار مقترح لصفحة "غير مصرح به"
  }
};

export default ProtectedRoute;
